// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../fromUnixTime/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var fromUnixTime = convertToFP(fn, 1);
export default fromUnixTime;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/fromUnixTime/index.js
// module id = 888
// module chunks = 0